<template>
  <div class="component-grid">
    <div class="container-grid">
      <div class="row-grid">
        <div class="column-grid" v-for="n in columns">
          <div class="gutter"></div>
        </div>
      </div>
    </div>
    <input type="number" slot="right" v-model="columns" number>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      default: 12,
      type: Number
    }
  }
}
</script>

<style lang="scss">
.component-grid {
  position: fixed;
  height: 100%;
  top: 0px;
  pointer-events: none;
  mix-blend-mode: multiply;
  display: none;

  .row-grid {
    display: flex;
  }

  .column-grid {
    width: 100%;
    height: 100vh;
    opacity: .05;

    .gutter {
      height: inherit;
      background: black;
    } 
  }

  input {
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    font-family: monospace;
    pointer-events: all;
    width: 4rem;
    height: 4rem;
    background: black;
    color: white;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 1rem;
    border: none;
    appearance: none; 
    &::-webkit-inner-spin-button, &::-webkit-outer-spin-button { 
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0; 
    }
    &:focus {
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Grid.vue?8baeeab4